<template>
  <Localizer>
    <v-app>
      <Navbar />
      <v-main>
        <v-container fluid>
          <v-alert v-if="alert.message" :type="alert.type" :value="true" dismissible>{{alert.message}}</v-alert>
          <router-view/>
        </v-container>
      </v-main>
    </v-app>
  </Localizer>
</template>

<script>
import Navbar from '@/components/layout/Navbar'
import Localizer from "./components/shared/Localizer";
import {  mapActions } from 'vuex'
export default {
  name: 'App',
  components: {
    Navbar,
    Localizer
  },
    computed: {
        alert()
        {          
            return this.$store.state.alert          
        }
    },
    methods: {
        ...mapActions({
            clearAlert: 'alert/clear' 
        })
    },
    watch: {
        $route (){
            // clear alert on location change
            this.clearAlert();
        },
        alert: function(val)
        {
          if(val.message)
            setTimeout(function() { this.clearAlert() } ,2500)
        }
    }
}
</script>

<style>
  @import '../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';

</style>
